import React from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  size?: 'md' | 'md-plus' | 'lg' | 'xl' | '2xl';
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, title, size = 'md' }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    md: 'max-w-2xl',
    'md-plus': 'max-w-3xl', // 10% увеличение от md (2xl -> 3xl)
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
    '2xl': 'max-w-[94rem]', // 30% шире чем xl (72rem * 1.3 ≈ 94rem)
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4 overflow-hidden">
      <div 
        className={`bg-gray-800 rounded-lg shadow-xl w-full min-w-0 mx-auto max-h-[90vh] overflow-y-auto overflow-x-hidden ${sizeClasses[size]}`}
      >
        <div className="sticky top-0 bg-gray-800 z-10 p-4 border-b border-gray-700 flex justify-between items-center">
          <h2 className="text-xl font-bold text-white">{title}</h2>
          <button 
            onClick={onClose} 
            aria-label="Close modal"
            className="text-gray-400 hover:text-white text-3xl leading-none font-bold transition-colors"
          >
            &times;
          </button>
        </div>
        <div className="p-6 min-w-0 overflow-x-hidden">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;